/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Used to alert the user when a new version of bulb has been released so the client can be refreshed.
 */
angular.module('bulbApp.alertsModule')
  .controller('MismatchedVersionAlertController', ['$cookies', '$filter', '$scope', 'BulbAjaxService',
    'BulbUtilitiesService', 'ALERT', 'CONFIG', MismatchedVersionAlertController]);

function MismatchedVersionAlertController(
  $cookies,
  $filter,
  $scope,
  BulbAjaxService,
  BulbUtilitiesService,
  ALERT,
  CONFIG,
) {
  const that = this;

  this.showVersionAlert = false;

  /**
   * Compares version coming in on all response headers to the version that was loaded into the config service.
   *
   * @param versionHeader from the response from the Ajax interceptor.
   */
  function checkVersions(versionHeader) {
    if (versionHeader !== CONFIG.env.buildVersion) {
      that.showVersionAlert = true;
    }
  }

  /**
   * Watch for changes on the version.
   */
  $scope.$watch(() => BulbUtilitiesService.version, (newVersion) => {
    if (newVersion) {
      checkVersions(newVersion);
    }
  });

  /**
   * Refresh the page.
   */
  this.refresh = function close() {
    location.reload();
  };
}
